import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

type CalendarLoadingProps = {
    isAdvancedMode: boolean;
};

function CalendarLoading({ isAdvancedMode }: CalendarLoadingProps) {
    return (
        <Box
            sx={{
                width: '100%',
                height: !isAdvancedMode ? 'calc(77vh - 85px)' : 'calc(77vh - 140px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <CircularProgress />
        </Box>
    );
}

export default CalendarLoading;
